var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"layout",attrs:{"id":"layout"}},[_c('div',{staticClass:"main"},[_c('keep-alive',{key:new Date() + ''},[_c('transition',{attrs:{"enter-active-class":"animate__animated animate__fadeIn"}},[_c('router-view')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }